// tslint:disable max-line-length
import * as Constants from "Data/Constants";
import {PARIS as VO} from "Data/VO";
import type { ILocationConfig } from "Interfaces/ILocationConfig";

export const ParisConfig: ILocationConfig = {
  city: "Paris",
  country: "France",
  interior: {
    width: 1664,
    itemslist: {
      give: {
        bg: [{ filename: "clipboard", x: -30, y: 25}],
        ICON_SIZE: 80,
        ICON_SPACING: 25,
        columns: 4,
        floatingItemsY: -50,
        width: 440,
        highlightFloatingItems: false,
        animateIn: "slideInFromRight",
        before_icon: "grocerylist-checkbox",
      },
      return: {
        width: 0,
        height: 0,
        floatingItemsY: 0,
        highlightFloatingItems: true,
        ICON_SIZE: 100,
        ICON_SPACING: 25,
        itemslots: [
          {
            x: 0,
            y: 145,
            width: 615,
            height: 150,
            acceptsMultiple: true,
            bg: [
              { filename: "island", x: 0, y: 140 },
              { filename: "itemring-paris", x: 0, y: 30 },
            ],
            dropSFX: "place-ingredient",
          },
        ],
        animateOut: "slideRight",
      },
    },
    bg: { filename: "paris-int-bg" },
  },
  exterior: {
    bg: [
      { filename: "paris-ext-bg-1", x: 0, y: 0 },
      { filename: "paris-ext-bg-2", x: 2048, y: 0 },
    ],
    margin: {
      left: 0,
      right: 0,
    },
    width: 3072,
  },
  items: {
    basil: {
      name: "Basil",
      sprite: "basil-full",
      sprite_hat: "basil-full",
      icon_int_give: "basil-full",
      icon_int_return: "basil-full",
      icon_ext: "basil-on",
      vo: {
        found: VO.IP11B,
        returned: VO.IP11A,
      },
    },
    beet: {
      name: "Beet",
      sprite: "beet-full",
      sprite_hat: "beet-full",
      icon_int_give: "beet-full",
      icon_int_return: "beet-full",
      icon_ext: "beet-on",
      vo: {
        found: VO.IP13B,
        returned: VO.IP13A,
      },
    },
    bellpepper: {
      name: "Bell Pepper",
      sprite: "greenpepper-full",
      sprite_hat: "greenpepper-full",
      icon_int_give: "greenpepper-full",
      icon_int_return: "greenpepper-full",
      icon_ext: "greenpepper-on",
      vo: {
        found: VO.IP15B,
        returned: VO.IP15A,
      },
    },
    butter: {
      name: "Butter",
      sprite: "butter-full",
      sprite_hat: "butter-full",
      icon_int_give: "butter-full",
      icon_int_return: "butter-full",
      icon_ext: "butter-on",
      vo: {
        found: VO.IP4B,
        returned: VO.IP4A,
      },
    },
    cheese: {
      name: "Cheese",
      sprite: "cheese-full",
      sprite_hat: "cheese-full",
      icon_int_give: "cheese-full",
      icon_int_return: "cheese-full",
      icon_ext: "cheese-on",
      vo: {
        found: VO.IP3B,
        returned: VO.IP3A,
        fact: VO.FP6,
      },
    },
    // cream: {
    //   name: "Cream",
    //   sprite: "cream-full",
    //   sprite_hat: "cream-full",
    //   icon_int_give: "cream-full",
    //   icon_int_return: "cream-full",
    //   icon_ext: "cream-on",
    // },
    drumstick: {
      name: "Drumstick",
      sprite: "drumstick-full",
      sprite_hat: "drumstick-full",
      icon_int_give: "drumstick-full",
      icon_int_return: "drumstick-full",
      icon_ext: "duck-on",
      vo: {
        found: VO.IP5B,
        returned: VO.IP5A,
        fact: VO.FP7,
      },
    },
    eggplant: {
      name: "Eggplant",
      sprite: "eggplant-full",
      sprite_hat: "eggplant-full",
      icon_int_give: "eggplant-full",
      icon_int_return: "eggplant-full",
      icon_ext: "eggplant-on",
      vo: {
        found: VO.IP14B,
        returned: VO.IP14A,
      },
    },
    // escargot: {
    //   name: "Escargot",
    //   sprite: "escargot-full",
    //   sprite_hat: "escargot-full",
    //   icon_int_give: "escargot-full",
    //   icon_int_return: "escargot-full",
    //   icon_ext: "escargot-on",
    // },
    garlic: {
      name: "Garlic",
      sprite: "garlic-full",
      sprite_hat: "garlic-full",
      icon_int_give: "garlic-full",
      icon_int_return: "garlic-full",
      icon_ext: "garlic-on",
      vo: {
        found: VO.IP7B,
        returned: VO.IP7A,
      },
    },
    // honey: {
    //   name: "Honey",
    //   sprite: "honey-full",
    //   sprite_hat: "honey-character-full",
    //   icon_int_give: "honey-full",
    //   icon_int_return: "honey-full",
    //   icon_ext: "honey-on",
    // },
    mussels: {
      name: "Mussels",
      sprite: "mussels-full",
      sprite_hat: "mussels-full",
      icon_int_give: "mussels-full",
      icon_int_return: "mussels-full",
      icon_ext: "mussels-on",
      vo: {
        found: VO.IP10B,
        returned: VO.IP10A,
      },
    },
    // mustard: {
    //   name: "Mustard",
    //   sprite: "mustard-full",
    //   sprite_hat: "mustard-full",
    //   icon_int_give: "mustard-full",
    //   icon_int_return: "mustard-full",
    //   icon_ext: "mustard-on",
    // },
    onion: {
      name: "Onion",
      sprite: "onion-full",
      sprite_hat: "onion-full",
      icon_int_give: "onion-full",
      icon_int_return: "onion-full",
      icon_ext: "onion-on",
      vo: {
        found: VO.IP9B,
        returned: VO.IP9A,
      },
    },
    parsley: {
      name: "Parsley",
      sprite: "parsley-full",
      sprite_hat: "parsley-full",
      icon_int_give: "parsley-full",
      icon_int_return: "parsley-full",
      icon_ext: "parsley-on",
      vo: {
        found: VO.IP8B,
        returned: VO.IP8A,
      },
    },
    // pear: {
    //   name: "Pear",
    //   sprite: "pear-full",
    //   sprite_hat: "pear-full",
    //   icon_int_give: "pear-full",
    //   icon_int_return: "pear-full",
    //   icon_ext: "pear-on",
    // },
    sourdough: {
      name: "Sourdough",
      sprite: "sourdough-full",
      sprite_hat: "sourdough-full",
      icon_int_give: "sourdough-full",
      icon_int_return: "sourdough-full",
      icon_ext: "sourdough-on",
      vo: {
        found: VO.IP2B,
        returned: VO.IP2A,
        fact: VO.FP5,
      },
    },
    tomato: {
      name: "Tomato",
      sprite: "tomatoe-full",
      sprite_hat: "tomatoe-full",
      icon_int_give: "tomatoe-full",
      icon_int_return: "tomatoe-full",
      icon_ext: "tomatoe-on",
      vo: {
        found: VO.IP1B,
        returned: VO.IP1A,
      },
    },
    // truffle: {
    //   name: "Truffle",
    //   sprite: "truffle-full",
    //   sprite_hat: "truffle-full",
    //   icon_int_give: "truffle-full",
    //   icon_int_return: "truffle-full",
    //   icon_ext: "truffle-on",
    // },
  },
  payoffs: {
    grilledcheese: { name: "Grilled Cheese", sprite: "finaldish-grilledcheese", position: { x: 0, y: 0 } },
    duck: { name: "Duck Confit", sprite: "finaldish-duck", position: { x: 0, y: 0 } },
    // escargot: { name: "Escargot", sprite: "finaldish-escargot", position: { x: 0, y: 0 } },
    mussels: { name: "Mussels", sprite: "finaldish-muscles", position: { x: 0, y: 0 } },
    frenchonionsoup: { name: "French Onion Soup", sprite: "finaldish-onionsoup", position: { x: 862.25 - 832, y: 0 } },
    ratatouille: { name: "Ratatouille", sprite: "finaldish_ratatouille", position: { x: 0, y: 0 } },
  },
  hidingspots: {
    "blueroof": {
      background: { sprite: "blueroof-back", x: 2754.5, y: 317 },
      hitarea: { x: 2951.5, y: 380 },
      foreground: { sprite: "blueroof-front", x: 2647, y: 128 },
    },
    "condiments": {
      background: { sprite: "condiments-stand", x: 1919.5, y: 241 },
      hitarea: { x: 2056.75, y: 343.25, width: 274.5, height: 204.5 },
    },
    "purpleroofstand": {
      background: { sprite: "purpleroofstand-back", x: 247, y: 286 },
      foreground: { sprite: "purpleroofstand-front", x: 237.5, y: 177.5 },
      hitarea: { x: 301, y: 386 },
    },
    "producesec": {
      background: { sprite: "producesec-back", x: 1987.5, y: 0 },
      foreground: [
        { sprite: "producesec-boxfront", x: 2557, y: 307 },
        { sprite: "producesec-greenjar", x: 2261.5, y: 350 },
      ],
      hitarea: {x: 2293, y: 393 },
    },
    "macaroontable": {
      foreground: { sprite: "macaroontable", x: 0, y: 0 },
      hitarea: { x: 135.75, y: 260.5, width: 271.5, height: 521 },
    },
    "misctable": {
      background: { sprite: "misctable-back", x: 793, y: 258.5 },
      foreground: { sprite: "misctable-front", x: 1023, y: 287.5 },
      hitarea: { x: 1084.5, y: 323.5 },
    },
    "delicounter": {
      background: { sprite: "delicounter-back", x: 732, y: -5 },
      foreground: { sprite: "delicounter-front", x: 319, y: 0 },
      hitarea: { x: 752.5 , y: 412.5 },
    },
    "redchecker": {
      background: { sprite: "redchecker-bottom", x: 0, y: 384 },
      foreground: { sprite: "redchecker-top", x: 0, y: 384 },
      hitarea: { x: 70.5, y: 565, width: 124, height: 261 },
    },
    "meatstand-bottom": {
      foreground: { sprite: "meatstand-bottom", x: 1132.5, y: 189.5 },
      hitarea: { x: 1451, y: 306.5 },
    },
    "meatstand-top": {
      foreground: { sprite: "meatstand-top", x: 1137, y: 0 },
      hitarea: { x: 1451, y: 306.5 },
    },
    "fruitstand-1": {
      foreground: { sprite: "fruitstand-1", x: 651.5, y: 626.5 },
      hitarea: { x: 1026, y: 736 },
    },
    "fruitstand-2": {
      foreground: { sprite: "fruitstand-2", x: 1405, y: 601.5 },
      hitarea: {x: 1669.5, y: 731 },
    },
    "fruitstand-3": {
      foreground: { sprite: "fruitstand-3", x: 2607.5, y: 510 },
      hitarea: {x: 2863.5, y: 589 },
    },
  },
  narratives: [
    {
      variations: [
// Level 1
        {
          hiddenitems: [
            { hidingspot: "purpleroofstand", item: { id: "tomato", scale: 0.3788, position: { x: -2.25, y: -26.25 }, rotation: 6.85 } },
            { hidingspot: "delicounter", item: { id: "sourdough", scale: 0.5989, position: { x: 22.25, y: 6.5 }, rotation: 28.83 } },
            { hidingspot: "producesec", item: { id: "cheese", scale: 0.5215, position: {x: -11.5 + (2662.5 - 2293), y: -22.75 + (382 - 393)} } },
            { hidingspot: "fruitstand-2", item: { id: "butter", scale: 1.0221, position: {x: 200, y: -50} } },
          ],
          itemslist: {
            give: {
              columns: 2,
            },
          },
        },
      ],
      payoff: "grilledcheese",
      vo: {
        all_items_returned: [VO.P10, Constants.VO_SPACING, VO.P15],
        exterior_idle: [VO.FP1, VO.FP2, VO.FP4, VO.FP10],
      },
    },
    {
      variations: [
        // Level 2
        {
          hiddenitems: [
            { hidingspot: "meatstand-bottom", item: { id: "drumstick", scale: 0.4641, position: { x: 69.5, y: -26.75 }, rotation: -109.71 } },
            { hidingspot: "fruitstand-3", item: { id: "garlic", scale: 0.409 / 0.4869, position: { x: 102.25, y: -50 }, rotation: -10.25 } },
            { hidingspot: "redchecker", item: { id: "parsley", scale: 0.5379, rotation: 45, position: { x: 15, y: -95} } },
            { hidingspot: "fruitstand-1", item: { id: "butter", scale: 0.409 / 0.5841, position: { x: 150, y: -15 }, rotation: -15 } },
          ],
          itemslist: {
            give: {
              columns: 2,
            },
          },
        },
      ],
      payoff: "duck",
      vo: {
        all_items_returned: [VO.P11, Constants.VO_SPACING, VO.P15],
      },
    },
    {
      variations: [
        // Level 3
        {
          hiddenitems: [
            { hidingspot: "purpleroofstand", item: { id: "cheese", scale: 0.3602, position: { x: 9.75, y: -208.25 }, rotation: 177.47 - 180, flipX: true } },
            { hidingspot: "fruitstand-1", item: { id: "garlic", scale: 0.3258 / 0.5861, position: { x: 114.75, y: -91 }, rotation: -73.13 } },
            { hidingspot: "fruitstand-3", item: { id: "sourdough", scale: 0.805, position: { x: -141.25, y: 56 }, rotation: -21.86, flipX: true } },
            { hidingspot: "producesec", item: { id: "onion", scale: 0.4588, position: { x: -25.75, y: -10.5 }, rotation: 2.33, flipX: false } },
            { hidingspot: "blueroof", item: { id: "butter", scale: 0.4661, position: { x: -53.25, y: -10 }, rotation: -0.09 } },
          ],
          itemslist: {
            give: {
              columns: 3,
            },
          },
        },
      ],
      payoff: "frenchonionsoup",
      vo: {
        all_items_returned: [VO.P12, Constants.VO_SPACING, VO.P15],
        exterior_idle: [VO.FP1, VO.FP2, VO.FP4, VO.FP9],
      },
    },
    {
      variations: [
        // Level 4
        {
          hiddenitems: [
            { hidingspot: "meatstand-bottom", item: { id: "mussels", scale: 0.276, position: { x: 286.75, y: -18.5 } } },
            { hidingspot: "misctable", item: { id: "butter", scale: 0.4144, position: { x: 21.5, y: 7.25 } } },
            { hidingspot: "redchecker", item: { id: "tomato", scale: 0.4463, position: { x: 22.5, y: -31.75 }, rotation: 44.95 } },
            { hidingspot: "producesec", item: { id: "parsley", scale: 0.2143 / 0.5851, position: { x: -13.25, y: -14.75 }, rotation: -48.84 } },
            { hidingspot: "purpleroofstand", item: { id: "garlic", scale: 0.1224 / 0.5861, position: { x: -47.25, y: -20.5 }, rotation: -40.54 } },
            { hidingspot: "blueroof", item: { id: "sourdough", scale: 0.4652, position: { x: -32.25, y: -5.75 }, rotation: -17.44 } },
          ],
          itemslist: {
            give: {
              columns: 3,
            },
          },
        },
      ],
      payoff: "mussels",
      vo: {
        all_items_returned: [VO.P13, Constants.VO_SPACING, VO.P15],
      },
    },
    {
      variations: [
        // Level 5
        {
          hiddenitems: [
            { hidingspot: "producesec", item: { id: "basil", scale: 0.4193, position: { x: -13.5, y: -5.5 }, rotation: -91.36 } },
            { hidingspot: "fruitstand-1", item: { id: "parsley", scale: 0.75, position: { x: -5, y: -60 }, rotation: -19.51} },
            { hidingspot: "meatstand-bottom", item: { id: "beet", scale: 0.45, position: { x: -75, y: -18 }, rotation: 60 } },
            { hidingspot: "misctable", item: { id: "tomato", scale: 0.3, position: { x: 22.5, y: 3.25 }, rotation: 43.44 } },
            { hidingspot: "delicounter", item: { id: "eggplant", scale: 0.3916, position: { x: 12.5, y: 9 }, rotation: 30 } },
            { hidingspot: "redchecker", item: { id: "garlic", scale: 0.6, position: { x: -0.25, y: -94 }, rotation: -65 } },
            { hidingspot: "blueroof", item: { id: "bellpepper", scale: 0.34, position: { x: 25, y: -15 }, rotation: -10 } },
            { hidingspot: "fruitstand-2", item: { id: "onion", scale: 0.45, position: { x: 285, y: 0 }, rotation: 40 } },
          ],
          itemslist: {
            give: {
              columns: 4,
              ICON_SIZE: 70,
              ICON_SPACING: 10,
              floatingItemsY: -35,
            },
          },
        },
      ],
      payoff: "ratatouille",
      vo: {
        all_items_returned: [VO.P14, Constants.VO_SPACING, VO.P15],
        exterior_idle: [VO.FP1, VO.FP2, VO.FP4, VO.FP8],
      },
    },
  ],
  npc: {
    name: "Rene",
    poses: {
      neutral: {sprite: "npc-rene-neutral"},
      excited: {sprite: "npc-rene-excited", position: {x: 0, y: 11}},
    },
  },
  vo: {
    give_quest: [VO.P1],
    show_items: [VO.P2, Constants.VO_SPACING, VO.P3],
    give_quest_idle: [VO.P4, VO.P5],
    return_items: [VO.P8, Constants.VO_SPACING, VO.P9],
    return_items_idle: [VO.P9],
    exterior: [VO.P6, Constants.VO_SPACING, VO.P7],
    exterior_idle: [VO.FP1, VO.FP2, VO.FP4],
    all_items_returned_idle: [VO.P15],
  },
  bgm: "LATW_740_pretty_happy_pacer_france_KK_extended",
};
